import { ParseTtime } from "../parsers";

//calculate total T times by adding them up
export const CalcTotalTimes = (t1, t2, t3, t4) =>
  ParseTtime(t1) + ParseTtime(t2) + ParseTtime(t3) + ParseTtime(t4);
